"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPressPositive = function SvgBPressPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M2.915 113.148a2.087 2.087 0 01-2.087-2.087V48.494a5.329 5.329 0 015.329-5.329h62.372a2.087 2.087 0 010 4.174H6.157c-.638 0-1.155.517-1.155 1.155v62.567a2.087 2.087 0 01-2.087 2.087zM101.475 123.005a2.087 2.087 0 01-2.087-2.087v-55.2a2.087 2.087 0 114.174 0v55.2a2.087 2.087 0 01-2.087 2.087z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M137.642 132.82H32.292a1.94 1.94 0 01-.695-.11l-29.475-9.865a2.087 2.087 0 01.695-4.07h98.658a2.087 2.087 0 010 4.175H15.603l17.03 5.697h89.802l-8.501-2.372a2.087 2.087 0 011.12-4.021l23.172 6.47a2.087 2.087 0 01-.563 4.097h-.021z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M74.26 67.075H12.752a2.087 2.087 0 010-4.174h61.51a2.087 2.087 0 110 4.174z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M12.71 57.19a2.087 2.087 0 01-.035-4.174h.062a2.087 2.087 0 110 4.174h-.027z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M22.623 57.19a2.087 2.087 0 01-.035-4.174h.062a2.087 2.087 0 110 4.174h-.027zM32.487 57.19a2.087 2.087 0 11-.035-4.174h.07a2.087 2.087 0 110 4.174h-.035z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M42.289 80.209H22.588a2.087 2.087 0 010-4.174h19.7a2.087 2.087 0 010 4.174z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M81.697 90.108h-59.13a2.087 2.087 0 010-4.174h59.13a2.087 2.087 0 010 4.174zM81.697 100.014h-59.13a2.087 2.087 0 110-4.174h59.13a2.087 2.087 0 110 4.174zM81.697 109.816h-59.13a2.087 2.087 0 110-4.174h59.13a2.087 2.087 0 110 4.174z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M109.774 67.158a33.489 33.489 0 01-22.817-8.946 2.087 2.087 0 012.838-3.06 29.405 29.405 0 0049.391-21.566 2.087 2.087 0 114.174 0c-.027 18.536-15.05 33.553-33.586 33.572z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M77.043 71.791a5.308 5.308 0 01-5.008-6.956l6.428-19.075A33.586 33.586 0 01108.056.042a33.58 33.58 0 11-10.783 64.695 2.087 2.087 0 011.551-3.874c12.972 5.199 27.811.55 35.498-11.122 7.686-11.671 6.096-27.14-3.804-37.004-9.94-9.879-25.468-11.373-37.11-3.57-11.64 7.802-16.16 22.733-10.8 35.682.197.466.216.988.056 1.468l-6.671 19.805a1.127 1.127 0 001.391 1.391l6.957-2.351a2.088 2.088 0 011.329 3.958l-6.957 2.344c-.536.197-1.1.308-1.67.327z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M97.565 52.751a2.087 2.087 0 01-2.087-2.441l2.164-12.633-2.087-2.004a2.105 2.105 0 012.977-2.977l2.838 2.782c.493.478.72 1.167.606 1.844l-1.642 9.551 8.577-4.508a2.087 2.087 0 011.941 0l8.578 4.508-1.642-9.551a2.087 2.087 0 01.598-1.85l6.957-6.762-9.586-1.392a2.087 2.087 0 01-1.573-1.14l-4.271-8.71-4.32 8.689a2.087 2.087 0 01-1.572 1.14l-13.774 2.004a2.088 2.088 0 11-.598-4.132l12.688-1.844 5.67-11.499a2.087 2.087 0 013.743 0l5.676 11.5 12.661 1.843a2.087 2.087 0 011.162 3.561l-9.162 8.947 2.17 12.633a2.087 2.087 0 01-3.026 2.205l-11.318-5.969-11.346 5.969a2.087 2.087 0 01-1.002.236z",
    fill: "#1B7"
  })));
};

var _default = SvgBPressPositive;
exports["default"] = _default;